import React from 'react';
import { motion } from 'framer-motion';
import { PURCHASE_LINK } from '../utils/constants';
export function CierreCTA() {
  return <section className="py-24 bg-orange-500 text-white text-center relative overflow-hidden" data-id="element-55">
      {/* Decorative circles */}
      <div className="absolute top-1/2 left-0 w-64 h-64 bg-orange-400 rounded-full blur-3xl -translate-y-1/2 -translate-x-1/2 opacity-50" data-id="element-56"></div>
      <div className="absolute top-1/2 right-0 w-64 h-64 bg-red-500 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 opacity-50" data-id="element-57"></div>

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-58">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl font-black uppercase mb-6" data-id="element-59">
          ¿Lista/o para dejar de improvisar?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl md:text-2xl text-orange-100 mb-6 max-w-2xl mx-auto font-medium" data-id="element-60">
          "Accedé hoy al mega pack completo y empezá a trabajar con material
          profesional, organizado y listo para usar."
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-61">
          <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="inline-block bg-gray-900 hover:bg-black text-white font-black text-2xl md:text-3xl py-6 px-10 rounded-2xl shadow-[0_8px_0_#1a1a1a] hover:shadow-[0_4px_0_#1a1a1a] hover:translate-y-[4px] transition-all uppercase tracking-wide" data-id="element-62">
            👉 QUIERO EL MEGA PACK AHORA
          </a>
        </motion.div>
      </div>
    </section>;
}